'use client';

import { useTranslations } from 'next-intl';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { X } from 'lucide-react';
import Image from 'next/image';
import styles from './ErrorModal.module.scss';
const SAD_MORPHY = '/assets/icons/morphy/sad-morphy.svg';
export interface ErroModalInterface {
  show: boolean;
  handleClose?: () => void;
}
const ErrorModal: React.FC<ErroModalInterface> = ({
  show,
  handleClose
}) => {
  const t = useTranslations();
  return <Modal show={show} onHide={handleClose} centered dialogClassName={styles.dialog} contentClassName={styles.content} data-sentry-element="Modal" data-sentry-component="ErrorModal" data-sentry-source-file="ErrorModal.tsx">
            <Modal.Body className={styles.body} data-sentry-element="unknown" data-sentry-source-file="ErrorModal.tsx">
                <div className={styles.errorWrapper}>
                    <button type="button" className={styles.closeButton} onClick={handleClose} aria-label="Close">
                        <X size={16} strokeWidth={2} aria-hidden data-sentry-element="X" data-sentry-source-file="ErrorModal.tsx" />
                    </button>

                    <div className={styles.morphy}>
                        <Image src={SAD_MORPHY} alt="" width={124} height={157} className={styles.morphyImg} priority data-sentry-element="Image" data-sentry-source-file="ErrorModal.tsx" />
                    </div>

                    <h2 className={styles.title}>{t('errorModal.title')}</h2>
                    <p className={styles.description}>
                        {t('errorModal.description')}
                    </p>
                </div>
            </Modal.Body>
        </Modal>;
};
export default ErrorModal;